import { useBoolean } from 'ahooks';
import { Space } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as CustomerLayout } from 'assets/svgs/customer-layout.svg';
import { ReactComponent as VendorLayout } from 'assets/svgs/vendor-layout.svg';
import { LinkButton } from 'components/atoms/button';
import { AppearanceMini } from 'components/organisms/module-settings/preferences/appearance-settings/appearance';
import { AppearanceSettingsDrawer } from 'components/organisms/module-settings/preferences/appearance-settings/appearance-settings-drawer';
import {
  Container,
  Content,
} from 'components/organisms/module-settings/preferences/styled';
import { useAccount } from 'hooks/use-account';
import { SettingsLabel } from '../../styles';
import { ProjectPlanBackgroundSettings } from './plan-background-settings';

export const AppearanceSettings: FC = () => {
  const {
    company: { companyName },
  } = useAccount();

  const [
    appearanceDrawerVisible,
    { setTrue: openAppearanceDrawer, setFalse: closeAppearanceDrawer },
  ] = useBoolean(false);

  return (
    <Container>
      <SettingsLabel>
        <FormattedMessage id="settings.organisation.appearance" />
      </SettingsLabel>
      <Content>
        <Space size={24}>
          <AppearanceMini
            title={
              <FormattedMessage
                id="settings.organisation.appearance.for"
                values={{ companyName }}
              />
            }
            icon={<VendorLayout />}
          />
          <AppearanceMini
            title={
              <FormattedMessage id="settings.organisation.appearance.for.customer" />
            }
            icon={<CustomerLayout />}
          />
        </Space>
      </Content>
      <LinkButton onClick={openAppearanceDrawer}>
        <FormattedMessage id="placeholder.change" />
      </LinkButton>

      <ProjectPlanBackgroundSettings />
      <AppearanceSettingsDrawer
        visible={appearanceDrawerVisible}
        onClose={closeAppearanceDrawer}
      />
    </Container>
  );
};
